/* eslint-disable jsx-a11y/anchor-is-valid */
import { IonButton, IonPage } from '@ionic/react';
import React from 'react';
import { ReactElement } from 'react-markdown/lib/react-markdown';
import { QuirkIonContent } from '../components/QuirkIonContent';
// eslint-disable-next-line css-modules/no-unused-class
import sharedstyles from '../styles/Shared.module.css';
export const Confirmation: React.FC<{
	action: () => {};
	cancelAction?: () => {};
	onDismiss: () => {};
	actionLabel: string;
	dismissLabel: string;
	content: ReactElement;
}> = ({ action, onDismiss, cancelAction, actionLabel, dismissLabel, content }) => {
	return (
		<IonPage>
			<QuirkIonContent>
				<div className={sharedstyles.contentWrapper}>
					{content}
					<div className={sharedstyles.toolbarButtonContainer}>
						<IonButton
							data-testid="ModalCancelButton"
							expand="block"
							color={'primary'}
							fill="outline"
							className="radius8"
							onClick={() => {
								onDismiss();
								cancelAction && cancelAction();
							}}
						>
							{dismissLabel}
						</IonButton>
						<IonButton
							data-testid="ModalActionButton"
							expand="block"
							color={'primary'}
							className="radius8"
							onClick={action}
						>
							{actionLabel}
						</IonButton>
					</div>
				</div>
			</QuirkIonContent>
		</IonPage>
	);
};
